<template>
  <header>
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="boosted" viewBox="0 0 50 50">
        <title>Cyber Protection</title>
        <path fill="#ff7900" d="M0 0h50v50H0z"/>
        <path fill="#fff" d="M7 35h35v7H7z"/>
      </symbol>
    </svg>
    <div class="px-3 py-2 bg-dark text-white">
      <div class="container-fluid">
        <div class="d-flex align-items-center justify-content-between -justify-content-lg-start">
          <div class="my-2 my-lg-0 me-lg-auto text-white text-decoration-none" style="cursor: pointer">
            <svg class="bi me-2" width="50" height="50" role="img" aria-label="Boosted"><use xlink:href="#boosted"/></svg>
          </div>
          <div class="d-flex">
            <div v-if="isMultipleAccounts" class="nav-link d-flex text-white p-0 text-center mr-2" @click="$router.push('/app/accounts').catch(()=>{})" style="cursor:pointer; flex-direction: column;">
              <i class="fa fa-random fa-2x pb-1" />
              <div>Changer de périmètre</div>
            </div>
            <div class="nav-link d-flex text-white p-0 text-center" @click="$router.push('/logout').catch(()=>{})" style="cursor:pointer; flex-direction: column;">
              <i class="fa fa-power-off fa-2x pb-1" />
              <div>Se déconnecter</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  computed: {
    isMultipleAccounts() {
      return localStorage.getItem('accounts');
    }
  }
};
</script>

<style src="./Header.scss" lang="scss"></style>
